<div #impersonateFrameDiv class="impersonated-user-active" style="display: none">
  <div class="impersonation-message">{{msg}}</div>
  <button class="dismiss-button" (click)="dismissBanner()">×</button>
</div>
